$(document).ready(function(){
   
    $('.product__description .specifications h3').on('click', function(e){
        e.preventDefault();

        if( $(this).parent().hasClass('show') ){
            $(this).parent().removeClass('show');
        } else {
            $(this).parent().addClass('show');
        }
    });

    var checkExist_fit = setInterval(function () {
        if ($('.fit_chart').length > 0) {
            clearInterval(checkExist_fit);
            
            $('.fit_chart').on('click', function(e){
                e.preventDefault();

                $('.size-chart-popup').addClass('active');
                $('body').addClass('overflow-hidden');
            });

            $('.size-chart-popup .drawer__close').on('click', function(e){
                e.preventDefault();
                $('.size-chart-popup').removeClass('active');
                $('body').removeClass('overflow-hidden');
            });

            $('.size_chat_icon svg').on('click', function(e){
                e.preventDefault();
                $('.size-chart-popup').removeClass('active');
                $('body').removeClass('overflow-hidden');
                
                $('#shopify-chat').show();
                waitAndOpen();
            });
        }
    }, 100);

    
    

    var checkExist = setInterval(function () {
        if ($('#shopify-chat').length > 0) {
            clearInterval(checkExist);

            $(window).on('scroll', function() {
                $('#shopify-chat').show();
            });

            setTimeout(function () {
                $('#shopify-chat').show();
            }, 10000);
        }
    }, 100);

});

function waitAndOpen() {
    const chat = document.getElementById('ShopifyChat');
    if (!chat || !chat.shadowRoot || !chat.shadowRoot.querySelector('button, [role="button"]')) {
        return setTimeout(waitAndOpen, 100); // check again in 100ms
    }
    chat.shadowRoot.querySelector('button, [role="button"]').click();
}